__turbopack_context__.v({
  "component": "index-module__C7J91W__component",
  "component__blackCTA": "index-module__C7J91W__component__blackCTA",
  "component__compact-gdt": "index-module__C7J91W__component__compact-gdt",
  "component__dark": "index-module__C7J91W__component__dark",
  "component__form": "index-module__C7J91W__component__form",
  "component__formField": "index-module__C7J91W__component__formField",
  "component__icon": "index-module__C7J91W__component__icon",
  "component__isHero": "index-module__C7J91W__component__isHero",
  "component__loader": "index-module__C7J91W__component__loader",
  "component__manual": "index-module__C7J91W__component__manual",
  "component__suggestions": "index-module__C7J91W__component__suggestions",
  "component__suggestionsActive": "index-module__C7J91W__component__suggestionsActive",
  "component__suggestionsList": "index-module__C7J91W__component__suggestionsList",
  "hide-for-large": "index-module__C7J91W__hide-for-large",
  "hide-for-large-only": "index-module__C7J91W__hide-for-large-only",
  "hide-for-medium": "index-module__C7J91W__hide-for-medium",
  "hide-for-medium-only": "index-module__C7J91W__hide-for-medium-only",
  "hide-for-small-only": "index-module__C7J91W__hide-for-small-only",
  "show-for-large": "index-module__C7J91W__show-for-large",
  "show-for-large-only": "index-module__C7J91W__show-for-large-only",
  "show-for-medium": "index-module__C7J91W__show-for-medium",
  "show-for-medium-only": "index-module__C7J91W__show-for-medium-only",
  "show-for-small-only": "index-module__C7J91W__show-for-small-only",
  "u-color-black": "index-module__C7J91W__u-color-black",
  "u-color-blue": "index-module__C7J91W__u-color-blue",
  "u-color-midnight": "index-module__C7J91W__u-color-midnight",
  "u-color-primary-dark": "index-module__C7J91W__u-color-primary-dark",
  "u-color-red": "index-module__C7J91W__u-color-red",
  "u-color-white": "index-module__C7J91W__u-color-white",
  "u-theme-black": "index-module__C7J91W__u-theme-black",
  "u-theme-blue": "index-module__C7J91W__u-theme-blue",
  "u-theme-dark": "index-module__C7J91W__u-theme-dark",
  "u-theme-light": "index-module__C7J91W__u-theme-light",
  "u-theme-red": "index-module__C7J91W__u-theme-red",
  "u-theme-white": "index-module__C7J91W__u-theme-white",
});
